import { Box, Checkbox, Grid, GridItem, Text } from '@chakra-ui/react';
import { FC } from 'react';

type HeaderElementProps = {
  text: string;
};

const HeaderElement: FC<HeaderElementProps> = ({
  text,
}: HeaderElementProps) => <Text color="inherit">{text}</Text>;

type CustomerListHeaderProps = {
  isSelectedAll: boolean;
  isIndeterminate: boolean;
  handleParentCheckboxClick: () => void;
};

export const CustomerListHeader: FC<CustomerListHeaderProps> = ({
  isSelectedAll,
  isIndeterminate,
  handleParentCheckboxClick,
}) => (
  <Box
    m={0}
    h="40px"
    w="100%"
    pl="16px" // list-item の padding-left に合わせる
    pr="16px" // スクロールバー分の余白
    borderBottom="2px"
    borderBottomColor="secondaryList.header.borderColor"
    bgColor="secondaryList.header.bgColor"
  >
    <Grid
      h="100%"
      templateColumns="1fr 4fr 10fr 15fr"
      gap={0}
      justifyItems="start"
      alignItems="center"
    >
      <GridItem h="100%" justifySelf="center">
        <Checkbox
          h="100%"
          isChecked={isSelectedAll}
          isIndeterminate={isIndeterminate}
          onChange={handleParentCheckboxClick}
        />
      </GridItem>
      <GridItem pl="20px">
        <HeaderElement text="ID" />
      </GridItem>
      <GridItem pl="20px">
        <HeaderElement text="顧客名" />
      </GridItem>
      <GridItem pl="20px">
        <HeaderElement text="顧客詳細" />
      </GridItem>
    </Grid>
  </Box>
);
